module.exports = __webpack_public_path__ + "img/img_nos_membres.9aceffbb.jpg";